module.exports = __webpack_public_path__ + "static/media/landingImage.fa3a2372.svg";